import { api } from './api';

export interface MaterialPrice {
  readonly materialId: string;
  readonly price: number;
  readonly rawPrice: number;
  readonly estimatedDays: number;
}

export interface Quote {
  readonly quoteId: string;
  readonly userId: string;
  readonly fileKey: string;
  readonly fileName: string;
  readonly volumeCm3: number;
  readonly surfaceAreaCm2: number;
  readonly boundingBox: {
    readonly width: number;
    readonly height: number;
    readonly depth: number;
  } | null;
  readonly prices: readonly MaterialPrice[];
  readonly status: 'processing' | 'ready' | 'review' | 'approved' | 'expired' | 'ordered' | 'rejected';
  readonly rejectionReason: string | null;
  readonly createdAt: string;
  readonly expiresAt: string;
}

export interface QuoteListResponse {
  readonly data: readonly Quote[];
  readonly pagination: { readonly lastKey: string | null };
}

export const quotesApi = {
  requestUploadUrl: async (input: {
    fileName: string;
    fileSize: number;
    contentType: string;
  }) => {
    const result = await api.post<{
      quoteId: string;
      uploadUrl: string;
      fileKey: string;
    }>('/quotes/upload-url', input);
    return result.data!;
  },

  get: async (id: string) => {
    const result = await api.get<Quote>(`/quotes/${id}`);
    return result.data!;
  },

  getDownloadUrl: async (id: string): Promise<string> => {
    const result = await api.get<{ downloadUrl: string }>(`/quotes/${id}/download-url`);
    return result.data!.downloadUrl;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/quotes/${id}`);
  },

  list: async (params?: { lastKey?: string; limit?: number }): Promise<QuoteListResponse> => {
    const query = new URLSearchParams();
    if (params?.lastKey) query.set('lastKey', params.lastKey);
    if (params?.limit) query.set('limit', String(params.limit));
    const qs = query.toString();
    const result = await api.get<readonly Quote[]>(`/quotes${qs ? `?${qs}` : ''}`);
    return {
      data: result.data ?? [],
      pagination: result.pagination ?? { lastKey: null },
    };
  },
};
